import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    wrapperSelector: String
  }

  connect() {
    this.wrapperSelector = this.wrapperSelectorValue || '.nested-fields'
  }

  add(event) {
    event.preventDefault()
    const content = this.templateContent()
    this.targetElement().insertAdjacentHTML('beforeend', content)
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest(this.wrapperSelector)
    
    // Find the hidden _destroy field
    const destroyField = wrapper.querySelector('input[name*="_destroy"]')
    
    if (destroyField) {
      // If it exists, set it to 1 (mark for destruction)
      destroyField.value = 1
      wrapper.style.display = 'none'
    } else {
      // If it doesn't exist, just remove the wrapper
      wrapper.remove()
    }
  }

  templateContent() {
    return this.templateElement().innerHTML
  }

  templateElement() {
    return this.element
  }

  targetElement() {
    return document.querySelector('#order-items')
  }
}
